import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import { colors, typography } from '../../styles';
import ContactModal from '../ContactModal';

const styles = css`
  display: none;
  @media (min-width: 992px) {
    display: block;
    position: absolute;
    top: 70px;
    right: 0;
    z-index: 1;
  }
  .OSCTag_wrapper {
    display: flex;
    background-color: ${colors.brand1};
    cursor: pointer;
    z-index: 35;
    padding: 10px 20px;
    border-radius: 0;
  }
  .OSCTag_image {
    width: 50px;
    height: 50px;
    border-radius: 25px;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    background-color: ${colors.neutral};
    border: 2px solid ${colors.white};
  }
  .OSCTag_content {
    position: relative;
    display: flex;
    flex-direction: column;
    margin: 0 0 0 10px;
    justify-content: center;
  }
  .OSCTag_headline {
    font-weight: 900;
    font-size: 20px;
    line-height: 1;
    color: ${colors.white};
    letter-spacing: 0;
    font-family: ${typography.Condensed};
    text-transform: uppercase;
    span {
      font-size: 13px;
      letter-spacing: 1.5px;
      text-transform: uppercase;
      font-weight: 800;
      display: block;
      font-family: ${typography.SansSerif};
    }
  }
  .OSCTag_phone {
    font-size: 16px;
    font-weight: 700;
    line-height: 1;
    letter-spacing: 0;
    color: ${colors.white};
    font-family: ${typography.Condensed};
    margin: 0 0 5px 0;
  }
`;

function OSCTagMobile({ builder, agent }) {
  const agentName = get(agent, 'name').split(' ')[0];
  return (
    <div className={styles} >
      <ContactModal builder={builder}>
        <div className="OSCTag_wrapper">
          <div className="OSCTag_image" style={{ backgroundImage: `url('${buildThumbnailUrl(get(agent, 'logo.contentUrl'), { width: 400, height: 400, exact: true })}')` }} />
          <div className="OSCTag_content">
            <div className="OSCTag_headline">
              Ask {agentName}
              {/* <span>Get Fast Answers!</span> */}
            </div>
            <div className="OSCTag_phone">
              {get(builder, 'telephone').replace(/\((\d{3})\)\s(\d{3})\s-\s(\d{4})/g, '($1) $2-$3')}
            </div>
          </div>
        </div>
      </ContactModal>
    </div>
  );
}

OSCTagMobile.propTypes = {
  builder: PropTypes.object.isRequired,
  agent: PropTypes.object,
};

OSCTagMobile.defaultProps = {
  agent: undefined,
};

export default withData(
  {
    builder: true,
    agent: true,
  },
)(OSCTagMobile);



// WEBPACK FOOTER //
// ./src/components/Header3/OSCTagDesktop.js